<template lang="pug">
  div.col-12(v-if="currentUser.rights.simCallsGateways == true")
    .content-wrapper
      h2.m-0.mb-3 Управлениe шлюзами
      button.btn.btn-info.col-2.mb-3(v-on:click='createGateway' v-if="currentUser.rights.simCallsGatewaysEdit") Добавить шлюз
      table.table.table-hover
        thead
          tr
            th(v-for="h in columnsHeader" v-bind:key="h.key" v-on:click="sortBy(h.key)" v-bind:class="{ active: sortKey == h.key }") {{ h.title }}
              span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc']")
        tbody
          tr(v-for="row in gatewaysList" v-bind:key="row.id")
            td(v-for="td in columnsHeader" v-bind:key="td.id") {{ row[td.key] }}
              span.td-actions(v-if="td.key === 'actions' && currentUser.rights.simCallsGatewaysEdit")
                i.far.fa-play.mr-2(v-if="!row.is_active" v-on:click='startGateway(row.id)')
                i.far.fa-pause.mr-2(v-if="row.is_active" v-on:click='stopGateway(row.id)')
                i.far.fa-pen.mr-2(v-on:click='showModal(row.id)')
                i.far.fa-trash.mr-2(v-on:click='deleteGateway(row.id)')
              span.td-actions(v-if="td.key === 'actions' && !currentUser.rights.simCallsGatewaysEdit")
                i.far.fa-play.mr-2(v-if="!row.is_active" v-on:click='startGateway(row.id)')
                i.far.fa-pause.mr-2(v-if="row.is_active" v-on:click='stopGateway(row.id)')
    modal(v-show="isModalVisible" v-on:close="closeModal")
      template(v-slot:header="")
        div.d-block.col-12
          h2 {{ modalData.gateway.name }}
          .form-group
            button.btn.btn-info.col-2(v-on:click="saveGateway") Сохранить
            span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            button.btn.btn-secondary.col-2(v-on:click='closeModal') Отмена
      template(v-slot:body="")
        div
          fieldset
            .form-group.col-12
              label Название
              input.form-control(v-model='modalData.gateway.name' type='text' placeholder='Введите название проекта' required='')
            .form-group.col-12
              label Проект
              select.form-control(v-model='modalData.gateway.project_id')
                option(v-for='(pr, pr_index) in projects' v-bind:key='pr_index' v-bind:value='pr.id') {{ pr.name }}
            .form-group.col-12
              label Префикс
              input.form-control(v-model='modalData.gateway.prefix' type='text' placeholder='Введите префикс' required='')
            .form-group.col-12
              label Провайдер
              input.form-control(v-model='modalData.gateway.provider' type='text' placeholder='Введите название провайдера' required='')
      template(v-slot:footer="")
        .form-group.d-flex.justify-content-end.col-12
          button.btn.btn-secondary.col-2(v-on:click="closeModal") Закрыть
  .alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type="button" data-dismiss="alert" aria-label="Close")
      span(aria-hidden="true") &times;
</template>

<script>
export default {
  data () {
    var columnsHeader = [
      {title: 'ID', key: 'id'},
      {title: 'Название', key: 'name'},
      {title: 'Проект', key: 'project_name'},
      {title: 'Активен', key: 'state'},
      {title: 'Префикс', key: 'prefix'},
      {title: 'Провайдер', key: 'provider'},
      {title: 'Используется', key: 'in_use'},
      {title: 'Дата последнего звонка', key: 'calldate'},
      {title: 'Действия', key: 'actions'}
    ]
    // const FORMAT = 'YYYY-MM-DD'
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      sortKey: '',
      isModalVisible: false,
      modalData: {},
      emptyModalData: null,
      sortOrders: sortOrders,
      columnsHeader: columnsHeader,
      openGateway: 0,
      projects: [],
      bases: [],
      gateways: []
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    gatewaysList: function () {
      let list = []
      this.gateways.forEach((item) => {
        item.actions = ''
        item.state = item.is_active ? 'Активен' : 'Остановлен'
        item.project_name = this.getProjectName(item.project_id)
        list.push(item)
      })
      if (this.sortKey) {
        let order = this.sortOrders[this.sortKey] || 1
        list = list.sort((a, b) => {
          let x = a[this.sortKey]
          let y = b[this.sortKey]
          if (typeof x == 'string') {
            x = x.toLowerCase()
            y = y.toLowerCase()
          }
          return (x === y ? 0 : x > y ? 1 : -1) * order
        })
      }
      return list
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser: function () {
      return this.$store.getters.user
    }
  },
  methods: {
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (Id = 0) {
      this.openGateway = Id
      if (Id < 1) {
        this.resetModalData()
        this.isModalVisible = true
        return true
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/gateway/get.php&id=' + Id)
        .then(response => {
          this.isModalVisible = true
          this.modalData.gateway = response.data.gateway
        })
    },
    closeModal () {
      this.openGateway = 0
      this.isModalVisible = false
    },
    resetModalData () {
      this.emptyModalData = {}
      this.modalData.gateway = {id: 0, project_id: 0, prefix: 0, name: "goip", provider: "", is_active: 0, in_use: 0, calldate: ""}
      this.emptyModalData.gateway = {id: 0, project_id: 0, prefix: 0, name: "goip", provider: "", is_active: 0, in_use: 0, calldate: ""}
    },
    createGateway () {
      this.showModal()
    },
    saveGateway () {
      let p = {}
      p.gateway = JSON.stringify(this.modalData.gateway)
      if (this.modalData.gateway.id > 0) {
        p.url = '/api/gateway/update.php'
      } else {
        p.url = '/api/gateway/add.php'
      }
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/simCalls.php', p)
        .then(() => { this.getGatewayList() })
      this.closeModal()
    },
    startGateway (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/gateway/update.php&is_active=1&id=' + id)
        .then(response => {
          this.getGatewayList()
        })
    },
    stopGateway (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/gateway/update.php&is_active=0&id=' + id)
        .then(response => {
          this.getGatewayList()
        })
    },
    deleteGateway (id) {
      if (!confirm('Подтвердите удаление шлюза')) {
        return false
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/gateway/delete.php&id=' + id)
        .then(response => {
          this.getGatewayList()
        })
    },
    getGatewayList () {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/gateway/get.php')
        .then(response => {
          this.gateways = response.data.list
        })
    },
    getProjectList () {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/get.php')
        .then(response => {
          this.projects = response.data.list
        })
    },
    getProjectName (id) {
      let p = this.projects.find(item => item.id == id)
      return p ? p.name : ''
    }
  },
  mounted () {
    this.resetModalData()
    this.getGatewayList()
    this.getProjectList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/simCalls/gateways.vue